import { all, call, takeLatest } from '@redux-saga/core/effects';
import axios from 'axios';
import { fork, put } from 'redux-saga/effects';
import {
  REQUEST_INFORMATION_REQUEST,
  REQUEST_INFORMATION_SUCCESS,
  REQUEST_INFORMATION_FAILURE,
  COMMON_FAILURE,
} from '../../actions';

import { requestInformationService } from '../../services';

export type requestInformationActionType = {
  type: typeof REQUEST_INFORMATION_REQUEST;
  memberID: string;
  history: string[];
};

function* getRequestInformation(action: requestInformationActionType): Generator<unknown> {
  try {
    const res = yield call(requestInformationService(action.memberID).getRequestInformation);
    yield put({
      type: REQUEST_INFORMATION_SUCCESS,
      res,
    });
  } catch (error) {
    if (axios.isAxiosError(error)) {
      yield put({
        type: REQUEST_INFORMATION_FAILURE,
        error: error.response,
      });
      yield put({
        type: COMMON_FAILURE,
        error: error.response,
      });
    }
    action.history.push('/systemError');
  }
}

function* watchGetRequestInformation() {
  yield takeLatest(REQUEST_INFORMATION_REQUEST, getRequestInformation);
}
export default function* requestInformationSaga(): Generator<unknown> {
  yield all([fork(watchGetRequestInformation)]);
}
